import { MODULES } from "@core/constants/modules.contants";
import {
  FormCheckBox,
  FormInput,
  SelectInput,
  Tab,
  TabContent,
  TabContentGroup,
  TabGroup,
} from "@policoders/ds";

import { IUserFormProps, useUserForm } from "./user.form.hook";

export const UserForm = ({ data, onChange }: IUserFormProps) => {
  const { accessOptions, accessModules, state, handleChange, handleAccessChange } = useUserForm({
    data,
    onChange,
  });

  return (
    <div>
      <div className="row">
        <div className="col-sm-12 col-lg-6">
          <FormInput
            type="text"
            label="Nome"
            field="name"
            required={true}
            value={state.name}
            onChange={handleChange}
          />
        </div>
        <div className="col-sm-12 col-lg-6">
          <FormInput
            type="email"
            label="E-mail"
            field="email"
            required={true}
            value={state.email}
            onChange={handleChange}
          />
        </div>
        <div className="col-sm-12 col-lg-6">
          <FormInput
            type="tel"
            label="Celular"
            field="cellphone"
            required={true}
            value={state.cellphone}
            onChange={handleChange}
          />
        </div>
        <div className="col-sm-12 col-lg-6">
          <FormInput
            type="tel"
            label="Telefone"
            field="telephone"
            required={true}
            value={state.telephone}
            onChange={handleChange}
          />
        </div>
      </div>
      <div>
        <TabGroup>
          <Tab tabId="tabAcessos" tabLabel="Acessos" active />
        </TabGroup>
        <TabContentGroup>
          <TabContent tabId="tabAcessos" active>
            <div className="row">
              {accessModules().map((x, i) => (
                <div key={i} className="col-sm-6 col-lg-4">
                  <SelectInput
                    label={x.label}
                    field={x.value.toLowerCase()}
                    value={state.modules[x.value?.toLowerCase() as MODULES] ?? ""}
                    options={accessOptions()}
                    onChange={handleAccessChange}
                  />
                </div>
              ))}
            </div>
          </TabContent>
        </TabContentGroup>
        <FormCheckBox
          label="Super usuário"
          field="superUser"
          value={!!state.superUser}
          className="text-danger mt-2"
          onChange={handleChange}
        />
      </div>
    </div>
  );
};
